import styled from "styled-components"
import { Main, OrnImg, Inscription } from "../shared/StylePage"
import square from '../img/Redorn/square.png'
import rhomb from '../img/Redorn/rhomb.png'
import sunsign from '../img/Redorn/Vector (2).png'


const Text = styled.div`
    display: flex;
    width: 100%;
   
`

const DivText = styled.div`
    display: grid;
    grid-template-columns: 160px auto;
    margin-top: 49px;
    gap: 31px;
    @media(width <= 828px){
        display: flex;
        flex-direction: column;
    }
`


export const Programma = () =>{
    return(
        <Main padtop='89' marbott='89' id="s3" wrap='wrap'>
            <OrnImg src={rhomb} top='200' left='1200' right='' bottom=''/>
            <OrnImg src={square} top='126' left='1018' right='' bottom=''/>
            <OrnImg src={sunsign} top='' left='1080' right='' bottom=''/>
            <Inscription size='39' weight='600' color='#E3022D'>ПРОГРАММА</Inscription>
            <DivText>
            <Inscription size='26' color='#E3022D'>10:00 - 10:30</Inscription>
            <Text >
                <Inscription size='23' color='#272727'>Церемония открытия форума</Inscription>
            </Text>
            <Inscription size='26' color='#E3022D'>10:30 - 11:30</Inscription>
            <Text>
                
                <Inscription size='23' color='#272727'>
                    Экспертная сессия <br /> 
                    «Новые вызовы – новые возможности. Сила сообществ» <br /> <br />
                    <Inscription size='23' color='#E3022D'> - <span>Влияние и вклад НКО в решение социальных проблем и повышение качества жизни</span> </Inscription> 
                    <Inscription size='23' color='#E3022D'> - <span>Партнёрство во имя развития. Опыт взаимодействия НКО, муниципалитета, бизнеса </span> </Inscription>                    
                    <Inscription size='23' color='#E3022D'> - <span>Социальное предпринимательство как вектор укрепления национального единства</span> </Inscription>
                    <Inscription size='23' color='#E3022D'> - <span>Воспитание патриотизма через связь поколений</span> </Inscription>
                </Inscription>
            </Text>
            <Inscription size='26' color='#E3022D'>11:30 - 12:00</Inscription>
            <Text>
                
                <Inscription size='23' color='#E3022D'>Кофе-пауза. Нетворкинг</Inscription>
            </Text>
            <Inscription size='26' color='#E3022D'>12:00 - 13:30</Inscription>
            <Text>
                
                <Inscription size='23' color='#E3022D'> - <span>Открытый диалог <br /> «Инструменты развития общественных советов при органах муниципальной власти»</span> <br /> <br />
                <Inscription size='23' color='#E3022D'> - <span>Рабочая сессия <br /> «Ресурсное сопровождение этнокультурной инфраструктуры <br /> на муниципальном и межмуниципальном уровнях»</span> </Inscription>  <br />
                <Inscription size='23' color='#E3022D'> - <span>Форсайт-сессия<br /> «Практики этноволонтерства. Вовлечение и масштабирование»</span> </Inscription>  <br />
                <Inscription size='23' color='#E3022D'> - <span>Проактивное пространство<br /> «Герои территорий: мастерская совершенствования. Презентация проектных практик»</span> </Inscription>  <br />
                </Inscription>  
            </Text>
            <Inscription size='26' color='#E3022D'>13:30 - 13:45</Inscription>
            <Text>
                
                <Inscription size='23' color='#E3022D'>Перерыв</Inscription>
            </Text>
            <Inscription size='26' color='#E3022D'>13:45 - 15:30</Inscription>
            <Text>
                
                <Inscription size='23' color='#E3022D'> - <span>Лаборатория социальных проектов «Поиск ресурсов для местных инициатив» </span> <br /> <br />
                <Inscription size='23' color='#E3022D'> - <span>Игротека «Родина – значит вместе!»</span> </Inscription>  <br />
                <Inscription size='23' color='#E3022D'> - <span>Мастерская медиа «ПРОдвижение местных сообществ и практик»</span> </Inscription>  <br />
                </Inscription>  
            </Text>
            </DivText>
            <Inscription size='23' color='#E3022D'>*Программа в каждом городе может меняться</Inscription>
        </Main>
    )
}